export const DASHBOARD_DATA = 'dashboard-data';
export const SET_MERCHANT_ID = 'set-merchant-id';
